import { render, staticRenderFns } from "./CampaignCreateAndEditDialog.vue?vue&type=template&id=28bac0da&scoped=true"
import script from "./CampaignCreateAndEditDialog.vue?vue&type=script&lang=js"
export * from "./CampaignCreateAndEditDialog.vue?vue&type=script&lang=js"
import style0 from "./CampaignCreateAndEditDialog.vue?vue&type=style&index=0&id=28bac0da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bac0da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
